import React from 'react';
import { Box } from '@mui/material';
import { HEADER_HEIGHT } from '../../constants';
import DesktopNavSection from './DesktopNavSection';
import DesktopSearchSection from '../Video/DesktopSearchSection';
import DesktopUserSection from './DesktopUserSection';
import DesktopProfileMenu from '../Auth/DesktopProfileMenu';
import ProfileManageModal from '../Auth/ProfileManageModal';
import LogoutDialog from '../Auth/LogoutDialog';

const DesktopHeader = ({
  // Props from parent
  url,
  videoTitle,
  loading,
  error,
  isLoggedIn,
  userEmail,
  userPhoto,
  user,
  drawerOpen,
  setDrawerOpen,
  hideLoginButton,
  // State from hooks
  t,
  isAnalyzePage,
  logoutDialogOpen,
  setLogoutDialogOpen,
  profileAnchorEl,
  profilePopoverOpen,
  profileManageModalOpen,
  // Handlers from hooks
  handleDrawerToggle,
  handleLogoClick,
  handleUrlChange,
  handleClearTitle,
  handleAnalyzeClick,
  handleLoginClick,
  handleProfileClick,
  handleProfileClose,
  handleProfileLogout,
  handleLogoutConfirm,
  handleProfileManage,
  handleProfileManageClose,
  handleProfileSave,
  handlePasswordChange,
  handleAccountDelete
}) => {
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        boxShadow: 'none',
        borderBottom: 'none',
        height: `${HEADER_HEIGHT}px`,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'auto'
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 0,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          justifyContent: 'flex-start',
          pointerEvents: 'auto'
        }}
      >
        {/* 좌측 네비게이션 */}
        <DesktopNavSection
          onDrawerToggle={handleDrawerToggle}
          onLogoClick={handleLogoClick}
        />

        {/* 중앙 검색 영역 */}
        <DesktopSearchSection
          url={url}
          onUrlChange={handleUrlChange}
          videoTitle={videoTitle}
          onTitleClear={handleClearTitle}
          onAnalyzeClick={handleAnalyzeClick}
          loading={loading}
          error={error}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          t={t}
        />

        {/* 우측 사용자 영역 */}
        <DesktopUserSection
          isLoggedIn={isLoggedIn}
          userPhoto={userPhoto}
          onProfileClick={handleProfileClick}
          onLoginClick={handleLoginClick}
          hideLoginButton={hideLoginButton}
          isAnalyzePage={isAnalyzePage}
          t={t}
        />

        {/* 프로필 팝오버 메뉴 */}
        <DesktopProfileMenu
          open={profilePopoverOpen}
          anchorEl={profileAnchorEl}
          onClose={handleProfileClose}
          onLogout={handleProfileLogout}
          onProfileManage={handleProfileManage}
          userEmail={userEmail}
          t={t}
        />

        {/* 로그아웃 다이얼로그 */}
        <LogoutDialog
          open={logoutDialogOpen}
          onClose={() => setLogoutDialogOpen(false)}
          onConfirm={handleLogoutConfirm}
          t={t}
        />

        {/* 프로필 관리 모달 */}
        <ProfileManageModal
          open={profileManageModalOpen}
          onClose={handleProfileManageClose}
          user={user}
          userEmail={userEmail}
          onSave={handleProfileSave}
          onPasswordChange={handlePasswordChange}
          onAccountDelete={handleAccountDelete}
        />
      </Box>
    </Box>
  );
};

export default DesktopHeader; 